import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { CompanyService } from '../../../_services/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-company-demands',
  templateUrl: './company-demands.component.html',
  styleUrls: ['./company-demands.component.css']
})
export class CompanyDemandsComponent implements OnInit {
  @Input() companyId;

  // for table
  private demands: object[];
  private demands_count: number;
  private page_number: number;
  private page_count: number;
  private page_indicators: number[];

  constructor(private service: CompanyService, private route: ActivatedRoute, private router: Router) { }

  filters = new FormGroup({
    client_id: new FormControl(),
    departure_id: new FormControl(),
    arrival_id: new FormControl(),
    vehicle: new FormControl(),
    quantity: new FormControl(''),
    departure_date: new FormControl(),
    arrival_date: new FormControl(),
    sell_price: new FormControl('')
  });

  ngOnInit() {

    this.filters.valueChanges.debounceTime(500).subscribe(
      (value) => {
        if (value.departure_date && value.departure_date.formatted) this.filters.patchValue({ departure_date: value.departure_date.formatted })
        if (value.arrival_date && value.arrival_date.formatted) this.filters.patchValue({ arrival_date: value.arrival_date.formatted })
        this.page_number = 1;
        this.refresh();
      }
    )

    this.refresh();


  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.companyId) {
      this.filters.reset();
      this.refresh();
    }
  }

  refresh() {
    let params = {};
    Object.assign(params, this.filters.value, { page: this.page_number });
    // this.service.getCompanyDemands(params)
    //   .subscribe(response => {
    //     this.page_number = parseInt(response.page);
    //     this.demands_count = parseInt(response.total_count);
    //     response.demands.forEach(function (demand) {
    //       this.service.getMatchingOffers(demand.id).subscribe(res => {
    //         Object.assign(demand, { matching_count: res.total_count });
    //       })
    //     }.bind(this));

    //     this.demands = response.demands;
    //     this.page_count = Math.ceil(this.demands_count / 25);   // Page Count
    //     // Page Indicators (for ngFor iterations)
    //     if (this.page_count < 10) {
    //       this.page_indicators = Array(this.page_count).fill(1);
    //     } else {
    //       this.page_indicators = Array(10).fill(1)
    //     }
    //   });
  }


  // Previous Page Button
  previousPage() {
    this.page_number--;
    this.refresh();
  }

  // Next Page Button
  nextPage() {
    this.page_number++;
    this.refresh();
  }

  // Go to page n°nb
  toPage(nb: number) {
    this.page_number = nb;
    this.refresh();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/company-modal/company-demands/company-demands.component.ts